import React from 'react';
import ReactDOM from 'react-dom';
import config from './configShared';
import './index.css';
import App from './AppStyled';
import * as serviceWorker from './serviceWorker';

if (config.ENV === 'dev') {
}

console.table({
  BACKEND_TYPE: config.BACKEND_TYPE,
  ENV: config.ENV,
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
